<template>
  <PagePaper>
    <div class="d-flex justify-end align-center mr-3">
      <div class="mb-4 mr-4">
        <DateRangeInput type="month" :selectedDates="selectedDates" @update="updateDates" />
      </div>
      <div class="text-right mb-4 mr-4">
        <Button @click="openOtherResultReportsPanel()">
          {{ $t('management.expensesReport.buttonOther') }}
        </Button>
      </div>
    </div>
    <div>
      <v-data-table
        :loading-text="table.loadingText"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        class="tableReport"
      >
        <template v-slot:[`item.expense`]="{ item }">
          {{ item.expense }}
        </template>
        <template v-slot:[`header.subtotal`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.subtotal`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.amount) }}</div>
        </template>
        <template v-slot:[`header.tax`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.tax) }}</div>
        </template>
        <template v-slot:[`header.discount`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.discount`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.discount) }}</div>
        </template>
        <template v-slot:[`header.total`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.total) }}</div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <!-- <div v-if="item.source === 'receipt'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  target="_blank"
                  :href="downloadReport(item._id)"
                  class="blueButton"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.expensesReport.table.downloadReport') }}</span>
            </v-tooltip>
          </div> -->
          <!-- <div v-if="item.expense === 'Órdenes de pago pagadas'"> -->
          <div>
            <!-- <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  class="mr-3"
                  v-on="on"
                  target="_blank"
                  dark
                  fab
                  :href="exportRoute(item)"
                  x-small
                  depressed
                  color="secondary">
                  <v-icon color="white">mdi-application-export</v-icon>
                </v-btn>
              </template>
              <span>Descargar estado de cuenta</span>
            </v-tooltip> -->
            <v-tooltip v-if="item.downloadCsv" top>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  class="mr-3"
                  v-on="on"
                  target="_blank"
                  dark
                  fab
                  :href="exportCsvRoute"
                  x-small
                  depressed
                  color="secondary">
                  <v-icon color="white">mdi-application-export</v-icon>
                </v-btn>
              </template>
              <span>Descargar CSV</span>
              <span>{{ $t('management.expensesReport.table.downloadXML') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.downloadXML" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  color="primary"
                  @click="downloadXML(item)"
                >
                  <v-icon>mdi-receipt</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.expensesReport.table.downloadXML') }}</span>
            </v-tooltip>
            <v-tooltip v-if="item.downloadTransactions" top>
              <template v-slot:activator="{ on }">
                <v-btn
                  class="mr-3"
                  v-on="on"
                  target="_blank"
                  dark
                  fab
                  :href="exportTransactionsRoute"
                  x-small
                  depressed
                  color="primary">
                  <v-icon color="white">mdi-application-export</v-icon>
                </v-btn>
              </template>
              <span>Descargar estado de cuenta</span>
            </v-tooltip>
          </div>
        </template>

        <!-- <template v-slot:footer="">
          <Pagination
            :itemsPerPage="table.options.itemsPerPage"
            :page="table.options.page"
            :total="totalRecords"
          />
        </template> -->
      </v-data-table>
      <v-data-table
        :loading-text="expensesTable.loadingText"
        :loading="expensesTable.loading"
        :headers="expensesTable.headers"
        :items="expensesTable.data"
        :options="expensesTable.options"
        class="tableReport"
      >
        <template v-slot:[`item.name`]="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div class="text-right">
            {{ item.total | toFixNumber(2) | numberWithComma | prefix('$') }}
          </div>
        </template>
      </v-data-table>
    </div>

    <OtherResultReportsPanel ref="otherResultReportsPanel" :selectedDates="selectedDates" />
  </PagePaper>
</template>

<script>
import DateRangeInput from '@/components/elements/DateRangeInput'
// import Pagination from '@/components/elements/Pagination'
import PagePaper from '@/components/elements/PagePaper'
import Button from '@/components/elements/Button'
import OtherResultReportsPanel from '@/components/sidePanels/OtherResultReports'
import formatCurrency from '@/utils/formatCurrency'

export default {
  name: 'ExpensesReport',
  components: {
    DateRangeInput,
    // Pagination,
    PagePaper,
    Button,
    OtherResultReportsPanel
  },
  data () {
    return {
      selectedDates: [],
      table: {
        loadingText: this.$i18n.t('management.expensesReport.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('management.expensesReport.table.headers.expense'), value: 'expense', sortable: false },
          { text: this.$i18n.t('management.expensesReport.table.headers.subtotal'), value: 'subtotal', sortable: false },
          { text: this.$i18n.t('management.expensesReport.table.headers.tax'), value: 'tax', sortable: false },
          { text: this.$i18n.t('management.expensesReport.table.headers.discount'), value: 'discount', sortable: false },
          { text: this.$i18n.t('management.expensesReport.table.headers.total'), value: 'total', sortable: false },
          { text: this.$i18n.t('management.expensesReport.table.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      expensesTable: {
        loadingText: this.$i18n.t('management.expensesReport.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('management.expensesReport.table.headers.category'), value: 'name', sortable: false },
          { text: this.$i18n.t('management.expensesReport.table.headers.total'), value: 'total', sortable: false }
          // { text: this.$i18n.t('management.expensesReport.table.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      }
    }
  },
  computed: {
    totalRecords () {
      return this.table.data.length
    },
    dates () {
      return this.selectedDates.length === 2
        ? [this.$moment(this.selectedDates[0]).startOf('day').toISOString(), this.$moment(this.selectedDates[1]).endOf('day').toISOString()]
        : [null, null]
    },
    exportCsvRoute () {
      const dates = this.dates
      let url = `${process.env.VUE_APP_API_URL}/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/expenses-invoiced`
      url += `?output=csv&access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      return url
    },
    exportTransactionsRoute () {
      const dates = this.dates
      let url = `${process.env.VUE_APP_API_URL}/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/transactions`
      url += `?access_token=${this.$store.state.login.token}`
      url += `&restaurant=${this.$store.state.currentRestaurant.data._id}`
      url += `&date>=${this.$moment(dates[0]).format('YYYY-MM-DD')}&date<=${this.$moment(dates[1]).format('YYYY-MM-DD')}`
      return url
    }
  },
  methods: {
    async downloadXML (item) {
      const startDate = this.$moment(this.selectedDates[0])
      const endDate = this.$moment(this.selectedDates[1])
      try {
        await this.$api.get(`/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export/expenses-invoiced?output=zip&kind=expense&restaurant=${this.$store.state.currentRestaurant.data._id}&createdAt>=${startDate.startOf('day').toISOString() || ''}&createdAt<=${endDate.endOf('day').toISOString() || ''}&status=${item.status}`)
        this.$toasted.show('Se enviará a su correo el link para descargar las facturas emitadas', { duration: 3000, type: 'success' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    updateDates (dates) {
      this.selectedDates = [ ...dates ]
      this.loadReports()
    },
    // Todo: integrate api
    loadReports: async function () {
      if (this.selectedDates.length === 2) {
        const [startDate, endDate] = this.selectedDates
        const params = {
          'createdAt>': startDate,
          'createdAt<': endDate
        }
        const restauratId = this.$store.state.currentRestaurant.data._id
        this.table.loading = true
        this.expensesTable.loading = true
        try {
          const response = await this.$api.get(`/v1/reports/${restauratId}/accounting/expenses`, params)
          const {
            invoicesReceivedMonthly,
            paidOrders,
            payOrdersInvoiced,
            pendingPaymentOrders,
            ordersWithOutSupport,
            outgoingCategories,
            monthlyTransactions
          } = response
          let dataItems = []
          dataItems.push({
            expense: this.$i18n.t('management.expensesReport.table.expenses.invoicedInMonth'),
            downloadXML: true,
            downloadCsv: true,
            status: 'received',
            name: 'invoices',
            ...invoicesReceivedMonthly
          })
          dataItems.push({
            expense: this.$i18n.t('management.expensesReport.table.expenses.monthlyTransactions'),
            downloadXML: false,
            downloadTransactions: true,
            status: 'received',
            name: 'transactions',
            ...monthlyTransactions
          })
          dataItems.push({
            expense: this.$i18n.t('management.expensesReport.table.expenses.payOrdersReceived'),
            downloadXML: false,
            status: 'paid',
            ...payOrdersInvoiced
          })
          dataItems.push({
            expense: this.$i18n.t('management.expensesReport.table.expenses.paidOrders'),
            downloadXML: false,
            status: 'paid',
            ...paidOrders
          })
          dataItems.push({
            expense: this.$i18n.t('management.expensesReport.table.expenses.pendingPaymentOrders'),
            downloadXML: false,
            ...pendingPaymentOrders
          })
          dataItems.push({
            expense: this.$i18n.t('management.expensesReport.table.expenses.ordersWithoutSupport'),
            downloadXML: false,
            ...ordersWithOutSupport
          })

          this.table.data = dataItems
          this.expensesTable.data = outgoingCategories
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.table.loading = false
        this.expensesTable.loading = false
      }
    },
    formatCurrency,
    // Todo: download file
    downloadReport (id) {
      // let url = `${process.env.VUE_APP_API_URL}/v1/invoices/${id}/download-invoice-pdf`
      // url += `?access_token=${this.$store.state.login.token}`

      // return url
    },
    openOtherResultReportsPanel () {
      this.$refs.otherResultReportsPanel.openPanel()
    }
  }
}
</script>

<style lang="scss" scoped>
  .tableReport {
    th {
      font-size: 12px;
    }

    td {
      font-size: 12px;
    }
  }

  .blueButton {
    background-color: #0F6FFF !important;
    color: #fff !important;
  }
</style>
